const IS_PANEL_VISIBLE_STORAGE_KEY = 'quote-rcpro-panel-visible';

type VisibleStates = 'hidden' | 'visible';

export const savePanelVisibilityState = (choice: VisibleStates) => {
  window.localStorage.setItem(IS_PANEL_VISIBLE_STORAGE_KEY, choice);
};

export const isPanelVisible = (): boolean => {
  const storageValue = window.localStorage.getItem(
    IS_PANEL_VISIBLE_STORAGE_KEY,
  );

  // since `storageValue` can be any string
  // the easiest thing to check is if its equal to `hidden`
  // if not, it's visible
  const isHidden = storageValue === 'hidden';

  return !isHidden;
};
